"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitValues = void 0;
const omitValues = (source, valuesToOmit) => Object.keys(source).reduce((result, key) => {
    const value = source[key];
    if (valuesToOmit.every((valueToOmit) => value !== valueToOmit)) {
        result[key] = source[key];
    }
    return result;
}, {});
exports.omitValues = omitValues;
//# sourceMappingURL=omitValues.js.map